(() => {
  const root = document.getElementById('tp-ilaria-root');
  const trigger = root && root.querySelector('.tp-il-prelaunch');
  if (!root || !trigger) return;
  const apiBase = String(root.dataset.apiBase || '').replace(/\/$/, '');
  if (!/^https:\/\//.test(apiBase)) return;
  let loading = false;

  async function serviceAvailable() {
    try {
      const response = await fetch(`${apiBase}/api/health`, {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store'
      });
      if (!response.ok) return false;
      const health = await response.json();
      return health && health.ok === true && health.ready === true && health.enabled === true;
    } catch (_) {
      return false;
    }
  }

  async function enforceKillSwitch() {
    const available = await serviceAvailable();
    root.hidden = !available;
    if (!available) trigger.hidden = true;
    return available;
  }

  async function start() {
    if (!await enforceKillSwitch()) return;
    trigger.hidden = false;
    window.setInterval(enforceKillSwitch, 60000);
  }

  trigger.addEventListener('click', async () => {
    if (loading) return;
    if (!await enforceKillSwitch()) return;
    loading = true;
    root.dataset.autoOpen = 'true';
    trigger.disabled = true;
    trigger.setAttribute('aria-busy', 'true');
    const style = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = root.dataset.styleUrl;
    document.head.appendChild(style);
    const script = document.createElement('script');
    script.src = root.dataset.scriptUrl;
    script.defer = true;
    script.onerror = () => {
      loading = false;
      trigger.disabled = false;
      trigger.removeAttribute('aria-busy');
    };
    document.head.appendChild(script);
  }, { once: true });
  start();
})();
